import { OfflinePaymentService } from "@/services";
export default {
  name: "account-list",
  components: {},
  props: [],
  data() {
    return {
      copyAccountFlag: true,
      copyDepositFlag: true,
      copyCardFlag: true,
      accountList: []
    };
  },
  computed: {},
  mounted() {
    this.getDepositAccount();
  },
  methods: {
    getDepositAccount() {
      OfflinePaymentService.getOfflineDepositAccount().then(response => {
        this.accountList = response.data.data;
      });
    },
    accountNumberCopy() {
      if (this.copyAccountFlag) {
        this.copyAccountFlag = false;
        this.$toast.success(
          this.$t(
            "operationsPage.deposit.category.rial.offline.accountList.copyAccount"
          )
        );
      } else {
        setTimeout(() => {
          this.copyAccountFlag = true;
        }, 3000);
      }
    },
    depositNumberCopy() {
      if (this.copyDepositFlag) {
        this.copyDepositFlag = false;
        this.$toast.success(
          this.$t(
            "operationsPage.deposit.category.rial.offline.accountList.copyDeposit"
          )
        );
      } else {
        setTimeout(() => {
          this.copyDepositFlag = true;
        }, 3000);
      }
    },
    cardNumberCopy() {
      if (this.copyCardFlag) {
        this.copyCardFlag = false;
        this.$toast.success("شماره کارت کپی شد.");
      } else {
        setTimeout(() => {
          this.copyCardFlag = true;
        }, 3000);
      }
    }
  }
};
